// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1I5xC","info":"UpdateTermsInfo_info__3vpr6"};